import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalDatePipe } from './local-date.pipe';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private localDate: LocalDatePipe
  ) {}

  transform(date: string | Date): string {
    const differenceInTime = new Date().getTime() - new Date(date).getTime();
    const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
    const rules = [
      {
        match: differenceInDays >= 0 && differenceInDays <= 90,
        label: this.localDate.transform(date),
      },
      {
        match: differenceInDays >= 91 && differenceInDays <= 329,
        label: this.translate.instant('TIMEAGO.MONTHS', {
          value: Math.floor(differenceInDays / 28),
        }),
      },
      {
        match: differenceInDays >= 330 && differenceInDays <= 400,
        label: this.translate.instant('TIMEAGO.YEAR'),
      },
      {
        match: differenceInDays > 400,
        label: this.translate.instant('TIMEAGO.YEARS'),
      },
    ];

    return rules.find((rule) => rule.match).label;
  }
}
